import SignupOutOfStockModal from './SignupOutOfStockModal'

export default SignupOutOfStockModal
